import { render } from "./EventModal.vue?vue&type=template&id=795f9741&scoped=true&ts=true"
import script from "./EventModal.vue?vue&type=script&lang=ts"
export * from "./EventModal.vue?vue&type=script&lang=ts"

import "./EventModal.vue?vue&type=style&index=0&id=795f9741&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795f9741"]])

export default __exports__